/* ══════════════════════════════════════════════════════════════════
   回到顶部。规矩和表头收放是同一条（见 section-header.js）：
   滑过第一屏之后，上滑露出、下滑收起；回到第一屏之内就收掉。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.ebBackToTopLoaded) return;
  window.ebBackToTopLoaded = true;

  var btn = document.querySelector('[data-eb-btt]');
  if (!btn) return;

  var DELTA = 4;
  var last = Math.max(window.scrollY || 0, 0);
  var ticking = false;

  function update() {
    var y = Math.max(window.scrollY || 0, 0);
    var delta = y - last;

    /* 浮层开着的时候不冒出来，免得压在抽屉/弹窗上面 */
    var blocked = !!(window.EB && window.EB.overlay && window.EB.overlay.active());

    if (blocked || y <= window.innerHeight) {
      btn.classList.remove('is-visible');
    } else if (delta < -DELTA) {
      btn.classList.add('is-visible');
    } else if (delta > DELTA) {
      btn.classList.remove('is-visible');
    }

    last = y;
    ticking = false;
  }

  update();
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });

  /* 浮层期间页面不滚，等下一次 scroll 再纠正就晚了；
     解锁时 EB 把滚动位置还原回去（eb-core: unlockScroll），那一跳不算用户下滑 */
  document.addEventListener('eb:overlay:open', function () {
    btn.classList.remove('is-visible');
  });
  document.addEventListener('eb:overlay:close', function () {
    last = Math.max(window.scrollY || 0, 0);
  });

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      || document.body.classList.contains('eb-animations-disabled');
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    btn.classList.remove('is-visible');
  });
})();
